module.exports = __webpack_public_path__ + "img/8.9451f93b.jpg";